// components/dashboard/OpDocAssociationModal.js

import { PulseLoader } from "react-spinners";

import CloseIcon from "@material-ui/icons/Close";
import DateRangeIcon from "@material-ui/icons/DateRange";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import AccountBalanceWalletIcon from "@material-ui/icons/AccountBalanceWallet";

import Pagination from "../Pagination";
import DocumentRow from "../DocumentRow";
import SearchBar from "../SearchBar";

const OpDocAssociationModal = ({ 
	isLoading,
	selectedDoc,
	documents,
	setOpenTabDocuments,
	handleOnChangeDocumentAssociation,
	sendAffectation,
	pagination,
	setPagination
}) => {

	const close = () => setOpenTabDocuments(false);

	const changePerPage = (e) => {
        setPagination({ page: 1, perPage: e.target.value });
    }

    const paginate = (perPage, pageNumber) => {
        setPagination({ ...pagination, page: pageNumber });
    }

	return (
		<div className="w-full h-full fixed top-0 left-0 flex text-black z-[70] bg-opacity-50 bg-black items-center justify-center">
			<div className="w-11/12 xl:w-[1000px] 2xl:w-[1319px] h-full bg-white rounded-lg shadow-xl p-8 z-100 relative overflow-x-auto overflow-y-scroll">
			<h3 className="font-bold text-xl pb-4">Suggestions de documents à associer</h3>
			<button 
				className="absolute top-0 right-0 px-2 rounded-xl m-4" 
				onClick={close}
			>
				<CloseIcon/>
			</button>	
				<section className="flex justify-between gap-8 mt-5">
					<section className="w1/3 fill-black">
						<SearchBar target="docs" />
					</section>
					<div className="w-full relative">
						<button 
							className="absolute right-0 color-[#FFF]" 
							onClick={() => setOpenTabDocuments(false)}
						>
							<CloseIcon style={{ color: '#FFF' }} />
						</button>
						<div className="overflow-auto rounded-lg w-full">
							<ul>
								{documents?.data.map((document, index) => {
									return (
										<li key={document.id}>
											<DocumentRow 
												document={document} 
												selectedDoc={selectedDoc}
												onChange={() => handleOnChangeDocumentAssociation(document)} 
											/>
										</li>
									)
								})}
							</ul>
						</div>
						<div>
							<div className="flex justify-between">
								<div className="flex items-center font-semibold">
									<p>Afficher:</p>
									<div className="relative border border-gray-300 rounded-lg min-w-[84px] mx-2 px-4 py-2">
										<select id="select-op-per-page" className="bg-white w-full rounded-lg" value={pagination.perPage ?? 100} onChange={changePerPage}>
											<option value="10">10</option>
											<option value="50">50</option>
											<option value="100">100</option>
										</select>
										<ArrowDropDownIcon pointerEvents="none" className="text-gray-400 right-2 top-1/2 -translate-y-1/2 absolute"/>
									</div>
									<p>par page</p>
								</div>
								<Pagination data={documents} paginate={paginate} />
								<button 
									type="button"
									className="bg-greenSuccess rounded-2xl text-white p-2 px-8 mt-4" 
									onClick={(e) => sendAffectation(selectedDoc)}
								>
									{isLoading ? <PulseLoader color={'white'} size={10} /> : 'Valider'}
								</button>
							</div>
						</div>
					</div>
				</section>
			</div>
		</div>
	);
}

export default OpDocAssociationModal;
